'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n"]);

var LARGE_BUTTON_BORDER_RADIUS = "36px";
var XL_BUTTON_BORDER_RADIUS = "30px";
var XL_BUTTON_PADDING = "50px";
var BUTTON_HEIGHT = "40px";
var SMALL_BUTTON_PADDING = "25px";
var SMALL_BUTTON_BORDER_RADIUS = "20px";

var COLOR = {
  darkSteelBlue: "#495c74",
  steelBlue: "#688098",
  facebookBlue: "#4565a0",
  darkFacebookBlue: "#2a477c",
  brightBlue: "#3b99fc",
  skyBlue: "#7cd5ff",
  waterBlue: "#146dca",
  veryLightSteelBlue: "#c3cbdf",
  lightDeepBlue: "rgba(59, 153, 252, 0.1)",
  lightShallowBlue: "#00c9e5",

  deepBlueHover: "#007ADF",
  secondary: "#405369",
  lightSecondary: "#546A84",
  paginationBlue: "#37495f",

  brightRoyalBLue: "#4b97f5",
  deepBlue: "#3b99fc",
  deepBluePale: "#E2F0FF",
  deppBlueBtn: "rgb(61,138,247)",
  darkDeepBlue: "rgb(29, 102, 206)",
  veryLightGray: "#f1f1f1",
  lineGray: "#e5e5e5",
  lightGray: "#aaaaaa",
  gray: "#888888",
  darkGray: "#4a4a4a",
  textBlack: "#333333",
  borderGray: "rgba(0, 0, 0, 0.23)",
  shadowGray: "rgba(0, 0, 0, 0.08)",
  hoverGrey: "rgba(0, 0, 0, 0.1)",
  lineGrey: "#d8d8d8",
  selectionGrey: "#f8f8f8",

  blueLevel1: "#002570",
  blueLevel2: "#004BB0",
  blueLevel4: "#007ADF",

  black: "#000000",
  white: "#ffffff",
  whiteTwo: "#f9f9f9",

  softRed: "#f15555",
  lightSoftRed: "rgba(241, 85, 85, 0.1)",

  green: "#80c640",
  greenPale: "#E6FFCF",
  darkGreen: "#67A033",
  springGreen: "#b6f67b",

  darkYellow: "#a7903f",
  darkYellowBrighter: "#AC932D",
  yellow: "#d3b84c",
  yellowPale: "#FEF5D9",
  lightYellow: "#f2d76b",
  silkyYellow: "#e9d230",
  pale: "#fef5d9",
  superDarkGray: "#333333",

  orange: "#ff8a23",

  darkNegativeRed: "#a72f31",
  negativeRed: "#F15555",
  lightRed: "#FF7D7D",

  newGrey: "#E5E5E5",
  bgGrey: "#F1F1F1",
  textGrey: "#888888",
  redPale: "#FFE9E9",

  deepBlueDark: "#0062b3"
};

var BUTTON_SHADOW = "0 15px 20px 0 rgba(0, 0, 0, 0.1)";
var CHECKBOX_NORMAL_SHADOW = "0 2px 7px 0 rgba(0, 0, 0, 0.1)";
var CHECKBOX_HOVER_SHADOW = "0 2px 15px 0 rgba(0, 0, 0, 0.25)";
var DROPDOWN_SHADOW = "0 0 20px 0 rgba(0, 0, 0, 0.15)";
var MODAL_OVERLAY = "rgba(0, 0, 0, 0.5)";

var ANIMATE = {
  FAST: "0.2s",
  NORMAL: "0.5s",
  SLOW: "1s"
};

var FLEX_CENTER = styled.css(_templateObject);
var INLINE_FLEX_CENTER = styled.css(_templateObject2);

exports.ANIMATE = ANIMATE;
exports.BUTTON_HEIGHT = BUTTON_HEIGHT;
exports.BUTTON_SHADOW = BUTTON_SHADOW;
exports.CHECKBOX_HOVER_SHADOW = CHECKBOX_HOVER_SHADOW;
exports.CHECKBOX_NORMAL_SHADOW = CHECKBOX_NORMAL_SHADOW;
exports.COLOR = COLOR;
exports.DROPDOWN_SHADOW = DROPDOWN_SHADOW;
exports.FLEX_CENTER = FLEX_CENTER;
exports.INLINE_FLEX_CENTER = INLINE_FLEX_CENTER;
exports.LARGE_BUTTON_BORDER_RADIUS = LARGE_BUTTON_BORDER_RADIUS;
exports.MODAL_OVERLAY = MODAL_OVERLAY;
exports.SMALL_BUTTON_BORDER_RADIUS = SMALL_BUTTON_BORDER_RADIUS;
exports.SMALL_BUTTON_PADDING = SMALL_BUTTON_PADDING;
exports.XL_BUTTON_BORDER_RADIUS = XL_BUTTON_BORDER_RADIUS;
exports.XL_BUTTON_PADDING = XL_BUTTON_PADDING;
//# sourceMappingURL=settings-9ee2f03f.js.map
